import React from 'react';

const ResumeStrengthMobileView = ({ progress }) => {
    const pointerPosition = `${progress}%`;
    return (
        <div className="progress-bar">
            <div className="progress" style={{ width: pointerPosition }}>
                <div className="pointer" style={{ left: pointerPosition }}></div>
            </div>
        </div>
    );
};

export default ResumeStrengthMobileView;
